import { ComponentProps, ReactNode } from 'react';

import useTrans from '../../hooks/ui/useTrans';
import Banner from '../Banner/Banner';
import Button from '../Button/Button';
import DialogModal from '../DialogModal/DialogModal';
import Inline from '../Inline/Inline';
import Stack from '../Stack/Stack';
import Title from '../Title/Title';

type ConfirmationDialogProps = {
    title?: ReactNode;
    onConfirm: () => void;
    onCancel?: () => void;
    children: ReactNode;
    iconLevel?: ComponentProps<typeof Banner>['level'];
    context: 'tenant-dashboard' | 'customer-area';
};

const ConfirmationDialog = ({
    title,
    onConfirm,
    onCancel,
    children,
    iconLevel = 'warning',
    context,
}: ConfirmationDialogProps) => {
    const trans = useTrans(
        context === 'tenant-dashboard'
            ? 'TenantDashboard.General.ConfirmationDialog.'
            : 'CustomerArea.Shared.ConfirmationDialog.'
    );
    const titleOrDefault = title ?? trans('Title');

    return (
        <DialogModal
            onCloseRequested={onCancel ?? onConfirm}
            isOpen
            width="regular"
        >
            <Stack>
                <Title>{titleOrDefault}</Title>

                <Banner level={iconLevel} withoutBackground>
                    {children}
                </Banner>

                <Inline horizontal="right">
                    {onCancel && (
                        <Button variant="subtle" onClick={onCancel}>
                            {trans('CancelButton')}
                        </Button>
                    )}

                    <Button onClick={onConfirm}>
                        {trans('ConfirmButton')}
                    </Button>
                </Inline>
            </Stack>
        </DialogModal>
    );
};

export default ConfirmationDialog;
